import React from 'react';
import { Text, mergeStyleSets, Callout, FontWeights } from '@fluentui/react';
import CircleLoader from '../components/Loader/CircleLoader/CircleLoader';


const classNames = mergeStyleSets({
    inputWrapper:
    {
        paddingBottom: '20px',

    },
    callout: {
        width: 420,
        maxWidth: '90%',
        padding: '20px 24px',
    },
    title: {
        marginBottom: 12,
        fontWeight: FontWeights.semilight,
    },

});

type Props = {
    isOpen: boolean;
    targetId: string | undefined;
    isLoading?: boolean;
    summaryIA?: string;
    onDismiss: () => void;
};

const SummaryIACallout: React.FC<Props> = ({
    isOpen,
    targetId,
    isLoading = false,
    summaryIA,
    onDismiss
}) => {

    if (!isOpen) return null;

    return (
        <Callout
            className={classNames.callout}
            role="dialog"
            gapSpace={0}
            target={`#${targetId}`}
            onDismiss={onDismiss}
            setInitialFocus
        >

            <div className={`search-form-dialog flex flex-column position-relative`}>

                <div className={`position-relative my-scroll-div`}>
                    <CircleLoader loaderClass='loader-large' loading={isLoading} />

                    {!isLoading &&
                        <div className={classNames.inputWrapper}>
                            <Text as="h1" block variant="xLarge" className={classNames.title}>
                                Riepilogo IA
                            </Text>
                            <div style={{ paddingLeft: 8, paddingRight: 8 }}>
                                <Text > {summaryIA || 'Nessun riepilogo disponibile'} </Text>
                            </div>
                        </div>
                    }
                </div>

            </div>

        </Callout>
    );
};

export default SummaryIACallout;